<template>
  <div class="preview" v-if="show" @click.self="close">
    <i class="el-icon-close close" @click="close"></i>
    <img :src="info.url" v-if="info.type !== 'video'" alt="">
    <video :src="info.url" v-if="info.type === 'video'" controls loop preload="auto"></video>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
    show: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    close() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "Preview";
</style>